const isTestBank = window.location.origin.includes("testbank")
export const APPID = process.env.REACT_APP_APPID
export const API_RUOYI = process.env.REACT_APP_API
export const API = isTestBank ? "http://test-delegate.newayz.com:8800" : process.env.REACT_APP_API
// 客群提升
export const MARKET_URL = process.env.REACT_APP_MARKET
export const MARKET_URL_AUTOPLAY = process.env.REACT_APP_MARKET_AUTOPLAY
// 门店大盘
export const GUERLAIN_URL = process.env.REACT_APP_GUERLAIN
export const URL_AUTH = process.env.REACT_APP_URL_AUTH
export const API_AUTH = process.env.REACT_APP_API_AUTH
const location = window.location
export const API_TOKEN = isTestBank
  ? "http://test-dmp-api.newayz.com:8800"
  : process.env.REACT_APP_API_TOKEN
// export const API_PASSPORT = process.env.REACT_APP_API_PASSPORT
export const API_REGISTER = isTestBank
  ? "http://test-cloud-api.newayz.com:8800"
  : process.env.REACT_APP_API_REGISTER
export const PATH_LOGIN = "/passport/login"
export const PATH_AUTH_CALLBACK = "/passport/auth"
export const PATH_PRIVACY_POLICY = "/privacypolicy"
export const URL_REDIRECT = location.origin + location.pathname + "#" + PATH_AUTH_CALLBACK
export const STORE_KEY_REDIRECT = "__redirect__"
export const API_INDICATOR = isTestBank
  ? "http://test-delegate.newayz.com:8800/delegate/quota"
  : process.env.REACT_APP_API_INDICATOR

// 根据启动模式判断项目
export const PROJECT_MODE = process.env.REACT_APP_MODE
// 是否农行环境模式
export const isNH = PROJECT_MODE === "NH"

export const PASSPORT_URL = isTestBank
  ? `${window.location.origin}/#/passport/login`
  : process.env.REACT_APP_PASSPORT!

// 是否为未WAYZ QA环境
export const isWAYZQA = process.env.REACT_APP_WAYZ_QA === "true"
// 地址查询接口
export const MAP_SEARCH_URL = isNH
  ? `${API}/v1/inputtips`
  : `https://openapi-api.newayz.com/v1/map/amp/v3/assistant/inputtips`

const IPV4Reg =
  /^((0{0,2}\d|0?\d{2}|1\d{2}|2[0-4]\d|25[0-5])\.){3}(0{0,2}\d|0?\d{2}|1\d{2}|2[0-4]\d|25[0-5])$/

// 如果URL 为ip时， 使用hostname
export const COOKIE_DOMAIN = IPV4Reg.test(location.hostname)
  ? location.hostname
  : location.hostname.replace(/^.*((\.[\w-]+){2})$/, "$1")

// 点点通地址
export const DDT_URL = process.env.REACT_APP_URL_DDT
export const DDT_API = process.env.REACT_APP_API_DDT

// 系统配置用户端地址
export const CLIENT_URL = process.env.REACT_APP_URL_CLIENT

// token
export const TokenKey = "authorization_token"
// expiresin
export const ExpiresInKey = "authorization_expires"
// 用户账户
export const UserNameKey = "user_name"
// 是否有系统配置权限
export const SystemAuthKey = "system_auth"
// 农行token
export const NHTokenKey = "jtoken"

// 飞吉特首页
export const POSITION_API = process.env.REACT_APP_POSITION_INSIGHTS
export const OPEN_API = process.env.REACT_APP_API_OPENAPI
export const MAP_API = process.env.REACT_APP_API_INDOOR

// 飞吉特转发接口前缀
export const TRANSPOND_PREFIX = "business/delegate"
